// extracted by mini-css-extract-plugin
module.exports = {"area-link":"dece2e673c--area-link--aSvaa"};